<template>
  <div id="app">
    <div class="conter">
      <router-view />
    </div>
    <!-- 开发工具（仅开发环境显示） -->
    <DevTools />
  </div>
</template>

<script>
import DevTools from './components/DevTools.vue'

export default {
  components: {
    DevTools
  }
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  font-family: "阿里妈妈数黑体 Bold";

  element.style {
    padding: 0px 0px 0px 0px;
  }
}

// .center {
//   max-width: 1220px;
//   height: 100%;
//   margin: 0px auto;
// }
// 关闭滚动条
// ::-webkit-scrollbar {
//   display: none;
// }

.el-table .el-table__cell {
  text-align: center;
}

@media (min-width: 1440px) {
  body {
    background-color: black;
  }

  #app {
    width: 1440px;
    margin: 0 auto;
  }
}
</style>
